export const RESET_PASSWORD_TYPE = 'resetPassword';
export const VERIFY_EMAIL_TYPE = 'verifyEmail';
export const VERIFY_AND_CHANGE_EMAIL_TYPE = 'verifyAndChangeEmail';
export const RECOVER_EMAIL_TYPE = 'recoverEmail';
